/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */


import 'tinymce';
import 'tinymce/models/dom';
import 'tinymce/icons/default';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/autoresize';
import 'tinymce/themes/silver';
import './plugins/proofreader/plugin';
import './plugins/upload-image/plugin';
import './plugins/simple-paste/plugin';
